import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utilitário de merge de classes Tailwind.
 *
 * Combina `clsx` (para condicionais) com `tailwind-merge` (para resolver
 * conflitos de classes Tailwind, ex: `px-2 px-4` → `px-4`).
 *
 * @param inputs - Classes CSS, arrays, objetos condicionais
 * @returns String de classes CSS mesclada e sem conflitos
 *
 * @example
 * ```ts
 * cn('px-2 py-1', isActive && 'bg-brand-primary', 'px-4')
 * // → 'py-1 bg-brand-primary px-4'  (px-2 removido por conflito com px-4)
 *
 * cn('text-sm font-medium', className)
 * // Padrão para merge de className em componentes
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
